export default "__VITE_ASSET__BSjQ83pE__"